import '@/lib/polyfills'
import '@fontsource-variable/montserrat/wght.css'
import '@fontsource-variable/montserrat/wght-italic.css'
import '@/assets/styles/tailwind.css'
import '@/assets/styles/root.scss'
import '@/assets/styles/icons.css' // GENERATED by `npm run icons`
import 'mapbox-gl/dist/mapbox-gl.css'

import posthog from 'posthog-js'
import ConfirmationService from 'primevue/confirmationservice'
import Tooltip from 'primevue/tooltip'
import { createApp } from 'vue'

import { consentPersistence, useUserStore } from '@/stores/user-store'

import App from './App.vue'
import { reveal } from './directives/reveal'
import setup from './setup'

// Chunk/CSS preload failures outside router navigation (stale hashed assets after a deploy)
window.addEventListener('vite:preloadError', () => {
  window.location.reload()
})

const app = createApp(App)

setup(app)

const posthogProjectToken = import.meta.env.VITE_POSTHOG_PROJECT_TOKEN
const posthogHost = import.meta.env.VITE_POSTHOG_HOST

if (posthogProjectToken && posthogHost) {
  posthog.init(posthogProjectToken, {
    api_host: posthogHost,
    // No surveys are run: skips loading surveys.js on every page
    disable_surveys: true,
    // Nothing is written to the device until the cookie banner is accepted
    persistence: consentPersistence(useUserStore().cookiePreference),
    capture_exceptions: {
      capture_unhandled_errors: true,
      capture_unhandled_rejections: true,
      capture_console_errors: false,
    },
  })

  // Tags every event so local/dev/prod are separable in the shared project
  posthog.register({ environment: import.meta.env.VITE_APP_ENV })

  app.config.errorHandler = (error) => {
    posthog.captureException(error)
  }
} else if (import.meta.env.DEV) {
  const missingVariable = posthogProjectToken ? 'VITE_POSTHOG_HOST' : 'VITE_POSTHOG_PROJECT_TOKEN'
  throw new Error(
    `${missingVariable} variable required by PostHog is missing or un-configured, this causes events to be silently missed. This error stops appearing once ${missingVariable} is configured`,
  )
}

app.use(ConfirmationService)
app.directive('tooltip', Tooltip)
app.directive('reveal', reveal)
app.mount('#app')
